import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  storeCurrencyWarning: {
    description:
      'Warning banner prompting the seller to revert to default currency if they encounter carrier issues with store currency on customs form.',
    defaultMessage:
      'Customs currency is being set by your International Settings. If a carrier rejects this shipment because of currency, you can override it using the button below',
    id: '/jSLpb',
  },
  storeCurrencyWarningAction: {
    description: 'Label for the action button in the store currency warning message',
    defaultMessage: 'Revert to {currency}',
    id: 'i81EJW',
  },
  singleOrderWarning: {
    description: 'customs.status.warning.singleOrderWarning',
    defaultMessage:
      'Currency of the order is {currencyList}. Customs value currency is {customsCurrencyCode}. Please double check for conversion accuracy.',
    id: 'ViZ/FS',
  },
  multiOrderMultiCurrencyWarning: {
    description: 'customs.status.warning.multiOrderMultiCurrencyWarning',
    defaultMessage:
      'One or more orders being shipped are in {currencyList}. Customs value currency is {customsCurrencyCode}. Please double check for conversion accuracy.',
    id: '+9YsRb',
  },
  multiOrderSingleCurrencyWarning: {
    description: 'customs.status.multiWarning',
    defaultMessage:
      'One or more orders being shipped are not in {customsCurrencyCode}. Customs value currency is {customsCurrencyCode}. Please double check for conversion accuracy.',
    id: '+hXFGO',
  },
});
